export const types = {
    //Sync
    FILL_POSTS:  'FILL_POSTS',
    CREATE_POST: 'CREATE_POST',
    CLEAR_POSTS: 'CLEAR_POSTS',
    REMOVE_POST: 'REMOVE_POST',
    LIKE_POST:   'LIKE_POST',
    UNLIKE_POST: 'UNLIKE_POST',

    //Async
    FETCH_POSTS_ASYNC: 'FETCH_POSTS_ASYNC',
    CREATE_POST_ASYNC: 'CREATE_POST_ASYNC',
    REMOVE_POST_ASYNC: 'REMOVE_POST_ASYNC',
    LIKE_POST_ASYNC:   'LIKE_POST_ASYNC',
    UNLIKE_POST_ASYNC: 'UNLIKE_POST_ASYNC',
};
